import { render, staticRenderFns } from "./LapKartuStok.vue?vue&type=template&id=8fc66d10"
import script from "./LapKartuStok.vue?vue&type=script&lang=js"
export * from "./LapKartuStok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports